import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSignupGate } from "@/context/SignupGate";
import Banned from "@/pages/Banned";

/**
 * ProtectedRoute — requires a logged-in user.
 *
 * Guests (unauthenticated visitors) that try to reach a protected route are
 * bounced to the guest-accessible /feed with the SignupGate modal already
 * open — so they land back inside the platform, see the beautiful feed, and
 * get a clear invitation to sign up.
 */
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { showGate } = useSignupGate();

  useEffect(() => {
    if (!loading && !user) {
      // Fire the gate right after redirect so the modal opens on /feed.
      showGate("default");
    }
  }, [loading, user, showGate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="text-white/70 text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/feed" replace />;
  }
  if (user.banned) {
    return <Banned />;
  }
  return children;
}
